<div class="container" *ngIf="itineraryDetail as itinerary;">
  <div class="titles">
    <h1>{{'SEAT_MAP_MODULE.TITLE_SELECT_SEATS'|transloco}}</h1>
    <h2>{{'SEAT_MAP_MODULE.DESCRIPTION_SEAT_SELECTION_AVAILABLE'|transloco}}</h2>
  </div>
  <div class="cotent-columns" *ngIf="(isLoadingSeatMap$|async) === false; else placeholder">
    <div class="column-left">
      <div class="box-itinerary">
        <div class="box-title">
          {{'SEAT_MAP_MODULE.OUTBOUND_FLIGHTS'|transloco}}
        </div>
        <div class="box-flight" [class.active]="flight?.IsSelected"
          [class.latest]="flightLatest(flight,departureFlights(itinerary))"
          *ngFor="let flight of departureFlights(itinerary)"
          (click)="selectFlight(itinerary,itinerary?.Sectors[0]?.SectorNumber,flight)">
          <div class="content" [class.active]="flight.IsSelected">
            <p class="date">{{flight.DepartureDate| date: 'EEE, d MMM yyyy' | dateFormat|titlecase}}</p>
            <span class="city">{{flight.DepartureAirport}}</span> <i aria-hidden="true" class="icon-arrow-forw"></i>
            <span class="city">{{flight.ArrivalAirport}}</span>
          </div>
          <div class="arrow" *ngIf="flight.IsSelected">
            <i aria-hidden="true" class="icon-arrow-down"></i>
          </div>
        </div> 
      </div>

      <div class="box-itinerary arrival" *ngIf="arrivalFlights(itinerary)">
        <div class="box-title">
          {{'SEAT_MAP_MODULE.RETURN_FLIGHTS'|transloco}}
        </div>
        <div class="box-flight" [class.active]="flight.IsSelected"
          [class.latest]="flightLatest(flight,arrivalFlights(itinerary))"
          *ngFor="let flight of arrivalFlights(itinerary)"
          (click)="selectFlight(itinerary,itinerary.Sectors[1].SectorNumber,flight)">
          <div class="content" [class.active]="flight.IsSelected">
            <p class="date">{{flight.DepartureDate| date: 'EEE, d MMM yyyy' | dateFormat|titlecase}}</p>
            <span class="city">{{flight.DepartureAirport}}</span> <i aria-hidden="true" class="icon-arrow-forw"></i>
            <span class="city">{{flight.ArrivalAirport}}</span>
          </div>
          <div class="arrow" *ngIf="flight.IsSelected">
            <i aria-hidden="true" class="icon-arrow-down"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="column-right">
      <div class="content-seat-map" *ngIf="(sectorAndFlightSelected$|async) as sector;">
        <div class="header">
          <div class="button-left"></div>
          <div class="content-center" *ngIf="sector?.lenght>0">
            <div class="info-airline">
              <img alt="airline" loading="lazy" [src]="sector.Flights[0]?.AirlineCode | airlineImage">
              <span>{{sector?.Flights[0]?.AirlineName | airlineName | uppercase}}</span>
            </div>
            <div class="info-flight">
              <p>{{sectorType(sector?.SectorNumber)|transloco|uppercase}}</p> <span>•</span>
              <p> {{sector?.Flights[0]?.DepartureDate| date: 'EEE, d MMM yyyy' | dateFormat|titlecase}}</p>
              <span class="line">|</span>
              <p>{{sector?.Flights[0]?.DepartureAirport}}</p><i aria-hidden="true" class="icon-arrow-down"></i>
              <p>{{sector?.Flights[0]?.ArrivalAirport}}</p>
            </div>
          </div>
          <div class="button-right"></div>
        </div>
        <div class="content-map">
          <div class="map">
            <div class="box-indicators">
              <div class="box-indicator occupied">
                <span></span>
                <p>
                  {{'SEAT_MAP_MODULE.NOT_AVAILABLE'|transloco}}
                </p>
              </div>
              <div class="box-indicator available">
                <span></span>
                <p>
                  {{'SEAT_MAP_MODULE.AVAILABLE'|transloco}}
                </p>
              </div>
              <div class="box-indicator selected">
                <span></span>
                <p>
                  {{'SEAT_MAP_MODULE.SELECTED'|transloco}}
                </p>
              </div>
            </div>
            <ng-container *ngIf="(isLoadingSeatMapFlight$|async)  === false; else placeholderSeatMapFlight">
              <app-seats-map [seatMapSeat]="(seatMapSeat$|async)" [seatMap]="(seatMap$|async)"></app-seats-map>
            </ng-container>
          </div>
          <ng-container *ngIf="(seatMapSeat$|async) as seats;else placeHolderPassengers">
            <div class="passengers">
              <div class="box-passengers">
                <div class="title">{{'SEAT_MAP_MODULE.SEATING'|transloco}}</div>
                <div class="passenger" *ngFor="let seat of seats">
                  <div class="name">
                    {{seat.FirstName}} {{seat.Surname}}
                  </div>
                  <ng-container *ngIf="seat.SeatNumber;else seatNotSelected">
                    <div class="seat">{{seat.SeatNumber}}</div>
                    <i aria-hidden="true" class="icon-trash" (click)="removeSeatInFlight(seat.SeatNumber)"></i>
                  </ng-container>
                  <ng-template #seatNotSelected>
                    <span class="not-seat">{{'SEAT_MAP_MODULE.NO_SEAT'|transloco}}</span>
                  </ng-template>
                </div>
              </div>
              <button [disabled]="!enableConfirm(seatMap.Seats)" [class.enabled]="enableConfirm(seatMap.Seats)"
                *ngIf="(seatMap$|async) as seatMap" (click)="saveSeatsConfirm(seatMap,itineraryDetail)">
                <ng-container *ngIf="!isLoadingSeatMapTransactions;else loading">
                  <ng-container *ngIf="enableConfirm(seatMap.Seats);else labelNoSeat">
                    {{'SEAT_MAP_MODULE.CONFIRM_SEATS'|transloco}}
                  </ng-container>
                  <ng-template #labelNoSeat>
                    {{'SEAT_MAP_MODULE.NO_SEAT'|transloco}}
                  </ng-template>
                </ng-container>
                <ng-template #loading>
                  <app-btn-loader [classColor]="loaderColor"></app-btn-loader>
                </ng-template>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #placeholder>
  <app-seat-map-desktop-placeholder></app-seat-map-desktop-placeholder>
</ng-template>
<ng-template #placeholderSeatMapFlight>
  <app-seat-map-flight-placeholder></app-seat-map-flight-placeholder>
</ng-template>
<ng-template #placeHolderPassengers>
  <div class="passengers-placeholder">
    <div class="box-passengers">
      <div class="title"></div>
      <div class="passenger" *ngFor="let seat of [].constructor(4)">
        <div class=" name">
        </div>
        <span class="not-seat"></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="showError">
  <ng-container *ngIf="seatMapError$|async as seatMapError">
    <app-form-error [imageUrl]="supportImg" [title]="translate(seatMapError.Title)" [isMobile]="isMobile$ | async"
      [description]="translate(seatMapError.Description)" [textButton]="translate(seatMapError.MainButtonText)"
      [textSecondaryButton]="translate(seatMapError.SecondaryButtonText)" (closed)="closeError(seatMapError.ErrorType)"
      (mainButton)="closeError(seatMapError.ErrorType)" (secondaryButton)="otherOption(seatMapError.ErrorType)" >
    </app-form-error>
  </ng-container>
</ng-container>